import React from "react";
import { SvgIcon } from "@mui/material";

export const PickaxeIcon = (props) => {
  return <SvgIcon {...props}>
    <path
      d="m1.8462 1.8462v5.5385h-1.8462v9.2308h1.8462v1.8462h1.8462v-1.8462h1.8462v-7.3846h1.8462v1.8462h1.8462v1.8462h1.8462v1.8462h1.8462v1.8462h1.8462v1.8462h1.8462v1.8462h1.8462v1.8462h1.8462v1.8462h3.6923v-3.6923h-1.8462v-1.8462h-1.8462v-1.8462h-1.8462v-1.8462h-1.8462v-1.8462h-1.8462v-1.8462h-1.8462v-1.8462h-1.8462v-1.8462h-1.8462v-1.8462h7.3846v-1.8462h1.8462v-1.8462h-1.8462v-1.8462h-9.2308v1.8462z" />
  </SvgIcon>;
};